module.exports = " <div class=row :class=classes _v-6284a29e=\"\"> <slot _v-6284a29e=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6284a29e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Row.vue
// module id = 764
// module chunks = 2